import { collectScreenInventory, readScreenItem } from './screen-inventory';
import { serializeScreenInventory } from './serialize-screen-inventory';
import type { PageDataResult } from './screen-inventory.types';

function currentRouteName (): string {
    // Required lazily so importing the Leo store does not build the app router.
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const { default: router } = require('@/vue-router/router');

    return String(router.currentRoute.value.name ?? '');
}

export function currentScreenInventory (): string | null {
    const routeName = currentRouteName();
    try {
        const items = collectScreenInventory(routeName);
        if (!items) return null;

        return serializeScreenInventory(items, { routeName, pageTitle: document.title });
    } catch (error) {
        console.error('Leo screen inventory failed', error);

        return null;
    }
}

export function readCurrentScreenItem (itemId: string): PageDataResult {
    return readScreenItem(currentRouteName(), itemId);
}
